import { pxToRem } from "@/util";
import { Box, Paper, Typography } from "@mui/material";
import Image from "next/image";
import React from "react";
import { makeStyles } from "tss-react/mui";
type props = {
  id: string;
  number: string;
  title: string;
  content: string;
  image: string;
  bg: string;
};
export default function MissionCard({
  id,
  number,
  content,
  image,
  bg = "#fff",
}: Partial<props>) {
  const { classes } = styles();

  return (
    <Paper className={`${classes.container}`} style={{ background: bg }}>
      <Box className={`${classes.head}`}>
        <Typography className={`${classes.headTxt}`}>{number}</Typography>
        <Typography className={`${classes.headTxt}`}>{id}</Typography>
      </Box>
      <Box className={`${classes.desc}`}>
        <Typography className={`${classes.descTxt}`}>{content}</Typography>
      </Box>
      <Box className={classes.imgCont}>
        <Image
          src={image || "/images/about/Arel Interior.svg"}
          fill
          objectFit="cover"
          alt="Arel Home Interior"
        />
      </Box>
    </Paper>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    width: "100%",
    minHeight: pxToRem(380),
    borderRadius: pxToRem(8),
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: theme.spacing(4),
    padding: theme.spacing(3),
  },
  head: {
    display: "flex",
    gap: theme.spacing(2),
  },
  headTxt: {
    fontWeight: 600,
    fontSize: pxToRem(20),
    color: theme.colors.white,
  },
  desc: {
    height: pxToRem(100),
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      paddingBottom: pxToRem(30),
    },
  },
  descTxt: {
    fontWeight: 400,
    fontSize: pxToRem(14),
    textAlign: "justify",
    color: theme.colors.white,
  },
  imgCont: {
    display: "flex",
    borderRadius: pxToRem(4),
    height: pxToRem(240),
    width: "100%",
    position: "relative",
    overflow: "clip",
    flex: 1,
    [theme.breakpoints.down("sm")]: {
      height: pxToRem(250),
      flex: "none",
      paddingTop: theme.spacing(4),
    },
  },
}));
